import { Box, Button, FormControl, FormLabel, Input, Stack, Text, FormErrorMessage } from '@chakra-ui/react'

export function ResetarCompreGanheForm({ onSubmit, isLoading, register, errors }) {
  return (
    <Box mx="auto" maxWidth="500px" borderWidth="1px" borderRadius="lg" p={6} my={4} boxShadow="md">
      <form onSubmit={onSubmit}>
        <Stack spacing={4}>
          <FormControl id="numero_pedido" isRequired isInvalid={!!errors.numero_pedido}>
            <FormLabel>Número do Pedido</FormLabel>
            <Input
              placeholder="Digite o número do pedido"
              {...register('numero_pedido', {
                required: 'Este campo é obrigatório',
              })}
            />
            <FormErrorMessage>{errors.numero_pedido && errors.numero_pedido.message}</FormErrorMessage>
          </FormControl>

          <Button colorScheme="blue" type="submit" isLoading={isLoading} loadingText="Processando">
            Resetar Link do Compre e Ganhe
          </Button>

          <Text fontSize="sm" color="gray.600">
            Esta ação irá excluir as fotos existentes e enviar novamente o link do Compre e Ganhe para o cliente.
          </Text>
        </Stack>
      </form>
    </Box>
  )
}
